import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'
import 'i18n'
import { finishRegistration } from '../actionCreators'
import Registration from './Registration'

const RegistrationWrapper = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    finishRegistration(dispatch, values)
      .then((errors) => {
        if(errors === null) {
          window.location.href = '/launcher/'
        } else {
          setSubmitting(false)
          setErrors({
            email: errors.user && errors.user.email || '',
            nonFieldError: errors.nonFieldError || '',
          })
        }
      })
  }

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    cellphone: '',
    companyName: '',
    country: '',
    city: '',
  }

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, t('At least 2 characters'))
      .max(50, t('At last 50 characters'))
      .required(t('Required')),
    lastName: Yup.string()
      .min(2, t('At least 2 characters'))
      .max(50, t('At last 50 characters'))
      .required(t('Required')),
    email: Yup.string()
      .email(t('Invalid email'))
      .required(t('Required')),
    password: Yup.string()
      .min(6, t('At least 6 characters'))
      .required(t('Required')),
    passwordConfirm: Yup.string()
      .oneOf(
        [Yup.ref('password'), null],
        t('Must match password'),
      )
      .required(t('Required')),
    cellphone: Yup.string()
      .required(t('Required')),
    companyName: Yup.string()
      .required(t('Required')),
    country: Yup.string()
      .required(t('Country')),
    city: Yup.string()
      .required(t('Required')),
  })

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      component={Registration}
      onSubmit={handleSubmit}
    />
  )
}

export default RegistrationWrapper
